import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './core/home/home.component';
import {ErrorComponent} from './error/error.component';
import {AuthGuard} from './auth/auth-guard.service';

const appRoutes: Routes = [
  {
     // path: '', component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard]
     path: '', redirectTo: '/audits', pathMatch: 'full'
  },
  {
    path: 'error', component: ErrorComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}
